const filterform = () => {
  /* eslint-disable */
  function at(n) {
    // ToInteger() abstract op
    n = Math.trunc(n) || 0;
    // Allow negative indexing from the end
    if (n < 0) n += this.length;
    // OOB access is guaranteed to return undefined
    if (n < 0 || n >= this.length) return undefined;
    // Otherwise, this is just normal property access
    return this[n];
  }

  const TypedArray = Reflect.getPrototypeOf(Int8Array);
  for (const C of [Array, String, TypedArray]) {
    Object.defineProperty(C.prototype, 'at', {
      value: at,
      writable: true,
      enumerable: false,
      configurable: true,
    });
  }
  /* eslint-enable */
  /* eslint-disable no-bitwise */
  /* eslint-disable no-unused-vars */
  /* eslint-disable no-lonely-if */
  const { history } = window;
  const filterForm = document.querySelectorAll('.filter-form-js');

  function csvToArray(str, delimiter = ',') {
    const headers = str.slice(0, str.indexOf('\n')).split(delimiter);
    const rows = str.slice(str.indexOf('\n') + 1).split('\n');
    const arr = rows.map(row => {
      const values = row.split(delimiter);
      const el = headers.reduce((object, header, index) => {
        const theObject = object;
        let valueSeparate = values[index];
        if (values[index]) {
          valueSeparate = values[index].split('|');
        }
        theObject[header.trim()] = valueSeparate;
        return theObject;
      }, {});
      return el;
    });

    return arr;
  }

  filterForm.forEach(form => {
    let dataPrice;
    if (form.classList.contains('filter-form-pricelist-js')) {
      dataPrice = form.getAttribute('data-csv');
    }
    form.addEventListener('change', e => {
      const numberRequiredField = e.currentTarget.querySelectorAll(
        '.c-label__container',
      ).length;
      const allChecked = [...e.currentTarget.querySelectorAll('input:checked')];
      const pirceListRender = form.querySelector('.response-pricelist-js');
      const shortButtons = document.querySelectorAll('.js-short-btn-filter');
      shortButtons.forEach(btn => {
        btn.classList.remove('is-active');
      });

      if (form.classList.contains('filter-form-one-by-one-js')) {
        if (form.classList.contains('filter-form-extend')) {
          let basicUrl = form.getAttribute('data-basic-url');
          if (
            parseInt(
              form.parentElement.parentElement.parentElement.getAttribute(
                'data-nested',
              ),
              10,
            ) !== 0
          ) {
            basicUrl += `${
              form.parentElement.parentElement.parentElement.parentElement
                .parentElement.id
            }/`;
          }
          const groupOption = form.querySelectorAll('.single-option-groups');
          let currentId = '';
          allChecked.forEach(input => {
            currentId += `${input.value}-`;
            const slugOption = input.value;
            basicUrl = `${basicUrl + slugOption}/`;
          });

          if (
            basicUrl !==
            `${window.location.href.replace(window.location.hash, '')}/`
          ) {
            history.replaceState({ page: e.target.value }, 'title 1', basicUrl);
          }

          const paramsUrl =
            window.location.protocol + form.getAttribute('data-basic-url');
          const currentUrl = window.location.href;
          const currentParam = currentUrl.replace(paramsUrl, '').split('/');

          groupOption.forEach((group, key) => {
            const marker = group.getAttribute('data-mark');
            group.classList.add('is-hidden');
            if (currentParam) {
              currentParam.forEach((param, key2) => {
                if (marker === param) {
                  group.classList.remove('is-hidden');
                }
              });
            }
          });

          form.querySelectorAll('.single-option-groups').forEach(group => {
            if (group.classList.contains('is-hidden')) {
              group.querySelectorAll('input').forEach(input => {
                const changeChecked = input;
                changeChecked.checked = false;
              });
            }
          });
          // change url
          let newUrl = form.getAttribute('data-basic-url');
          if (
            parseInt(
              form.parentElement.parentElement.parentElement.getAttribute(
                'data-nested',
              ),
              10,
            )
          ) {
            newUrl += `${
              form.parentElement.parentElement.parentElement.parentElement
                .parentElement.id
            }/`;
          }
          [...document.querySelectorAll('input:checked')].forEach(el => {
            const slugOption = el.value;
            newUrl = `${newUrl + slugOption}/`;
          });
          // if (newUrl !== window.location.href) {
          if (
            newUrl !==
            `${window.location.href.replace(window.location.hash, '')}/`
          ) {
            history.replaceState({ page: e.target.value }, 'title 1', newUrl);
          }
        } else if (e.target.getAttribute('data-order') !== null) {
          const order = e.target.getAttribute('data-order') * 1 + 1;
          const elShow = document.querySelector(`.js-order-${order}`);
          if (elShow) {
            elShow.classList.remove('hidden-group');
          }
        }
      }
      if (e.currentTarget.classList.contains('filter-form-extend')) {
        const markerForm = e.currentTarget.getAttribute('data-marker');
        const markerFilterContent = document.querySelectorAll(
          '.filter-js-marker',
        );
        let idSe = '';
        allChecked.forEach(el => {
          idSe += `${el.value}-`;
        });
        markerFilterContent.forEach(parent => {
          const parentMarker = parent.getAttribute('data-marker');
          const sections = parent.querySelectorAll('.inner-content-js');
          const checkedAllSecond = [
            ...e.currentTarget.querySelectorAll('input:checked'),
          ];
          const allCheckedToSplice = [...allChecked];
          allCheckedToSplice.splice(-1);
          let idSe2 = '';
          allCheckedToSplice.forEach(el => {
            idSe2 += `${el.value}-`;
          });
          sections.forEach(se => {
            if (parentMarker === markerForm) {
              se.classList.remove('is-active');
              if (idSe.slice(0, -1) === se.id) {
                se.classList.add('is-active');
              } else if (checkedAllSecond[0].value === se.id) {
                se.classList.add('is-active');
              } else if (idSe2.slice(0, -1) === se.id) {
                se.classList.add('is-active');
              }
            }
          });
          let currentId = '';
          checkedAllSecond.forEach(element => {
            currentId += `${element.value}-`;
          });
          const currentElem = document.getElementById(currentId.slice(0, -1));
          const mark = checkedAllSecond[checkedAllSecond.length - 1].value;
          const elemById = `.single-option-groups[data-mark="${mark}"]`;
          if (!document.querySelector(elemById)) {
            if (currentElem) {
              currentElem.scrollIntoView(true);
            }
          } else {
            Array.from(checkedAllSecond)
              .at(-1)
              .parentElement.scrollIntoView(true);
          }
        });
      } else if (numberRequiredField === allChecked.length) {
        if (e.currentTarget.classList.contains('filter-form-tax-js')) {
          const taxonomyBox = document.querySelectorAll('.taxonomy-content-js');
          taxonomyBox.forEach(tax => {
            const taxMarker = tax.id;
            tax.classList.remove('is-active');
            if (taxMarker === allChecked[0].value) {
              tax.classList.add('is-active');
            }
          });
        } else if (
          e.currentTarget.classList.contains('filter-form-inner-block-js')
        ) {
          const markerForm = e.currentTarget.getAttribute('data-marker');
          const markerFilterContent = document.querySelectorAll(
            '.filter-js-marker',
          );
          markerFilterContent.forEach(parent => {
            const parentMarker = parent.getAttribute('data-marker');
            const sections = parent.querySelectorAll('.inner-content-js');
            sections.forEach(se => {
              if (parentMarker === markerForm) {
                const seMarkers = se.id.split('&');
                const checkedValue = Array.from(allChecked, (x, k) => x.value);
                const result = checkedValue.every(element =>
                  seMarkers.includes(element),
                );
                se.classList.remove('is-active');
                if (result) {
                  se.classList.add('is-active');
                }
              }
            });
          });
        }
      }
      // pricelist
      if (
        e.currentTarget.classList.contains('filter-form-pricelist-js') &&
        allChecked.length > 0
      ) {
        // let output = '<p> Niestety, akrualnie brak danych </p>';
        let output = '';
        const option = [];
        allChecked.forEach(opt => {
          const parentItem = opt.parentNode;
          const inputTitle = parentItem.querySelector('.c-label__title')
            .innerText;
          option.push(inputTitle);
        });

        if (dataPrice) {
          fetch(dataPrice, {
            headers: {
              'Content-type': 'text/csv;charset=UTF-8',
            },
          }).then(r => {
            r.text().then(d => {
              const contentCsv = d;
              const dataConvert = csvToArray(contentCsv);
              const { lang } = document.documentElement;
              const transFee = lang === 'pl' ? 'Wpisowe' : 'Registration fee';
              const transCharges =
                lang === 'pl'
                  ? 'Możliwe formy opłaty za studia'
                  : 'Available forms of payment for studies';
              dataConvert.forEach(data => {
                if (data.option !== '') {
                  if (
                    data.option.sort().join(',') === option.sort().join(',')
                  ) {
                    const entryFee = data.entry_fee;
                    output = '<div class="c-table-pricelist">';

                    if (entryFee !== '') {
                      output +=
                        '<div class="c-table-pricelist__single-column">';
                      output += `<span class="u-font-color--5 c-table-pricelist__title">${transFee}</span>`;
                      output +=
                        '<div class="c-table-pricelist__option-wrapper">';

                      entryFee.forEach(el => {
                        const pricePart = el.split('&');
                        output += `<div class="c-table-pricelist__single-option">
                        <span class="c-table-pricelist__label u-text--strong u-font-color--1">${
                          pricePart[0]
                        }</span>`;
                        if (pricePart[1] !== undefined) {
                          output += `<span class="c-table-pricelist__price">${
                            pricePart[1]
                          }</span>`;
                        }
                        output += ' </div>';
                      });

                      output += '</div>';
                      output += '</div>';
                    }

                    if (data.charges !== '') {
                      output +=
                        '<div class="c-table-pricelist__single-column">';
                      output += `<span class="u-font-color--5 c-table-pricelist__title">${transCharges}</span>`;
                      output +=
                        '<div class="c-table-pricelist__option-wrapper">';

                      data.charges.forEach(el => {
                        const pricePart = el.split('&');
                        output += `<div class="c-table-pricelist__single-option">
                        <span class="c-table-pricelist__label u-text--strong u-font-color--1">${
                          pricePart[0]
                        }</span>`;
                        if (pricePart[1] !== undefined) {
                          output += `<span class="c-table-pricelist__price">${
                            pricePart[1]
                          }`;
                          if (pricePart[2] !== undefined) {
                            output += `<br>${pricePart[2]}`;
                          }
                          output += '</span>';
                        }
                        output += ' </div>';
                      });

                      output += '</div>';
                      output += '</div>';
                    }

                    output += '</div>';
                  }
                }
              });
              pirceListRender.innerHTML = output;
            });
          });
        }
      }
    });

    if (
      form.classList.contains('filter-form-tax-js') ||
      form.classList.contains('filter-form-inner-block-js') ||
      form.classList.contains('filter-form-extend')
    ) {
      if (form.getAttribute('data-checked')) {
        const paramsUrl = form.getAttribute('data-checked');
        const allInputs = form.querySelectorAll('input');
        allInputs.forEach(input => {
          paramsUrl.split('&').forEach(param => {
            if (param === input.value) {
              const elParent = input.closest('.single-option-groups');
              if (elParent === null) {
                input.click();
              } else if (!elParent.classList.contains('is-hidden')) {
                input.click();
              }
            }
          });
        });
      } else if (!form.classList.contains('filter-form-js-disable-first')) {
        const formEvent = new Event('change');
        if (form.classList.contains('filter-form-inner-block-js')) {
          const checkIsBlock = document.querySelectorAll(
            '.acf-block-component',
          );
          if (checkIsBlock.length === 0) {
            form.querySelector('.filter-form-inner-block-js input').click();
          }
        } else {
          const inputTax = form.querySelector('.filter-form-tax-js input');
          if (inputTax) {
            inputTax.click();
          }
        }
        form.dispatchEvent(formEvent);
      }
    } else if (form.classList.contains('filter-form-first-active-js')) {
      form.querySelector('.filter-form-first-active-js input').click();
    }
  });
};

export default filterform;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/filterform.js